import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Sparkles, X, ZoomIn, ZoomOut } from "lucide-react";
import StarBackground from "../components/StarBackground";

// Translation object for My Work page
const translations = {
  en: {
    backToHome: "Back to Home",
    myWork: "My Work",
    more: "more",
    dec2025: "December 2025",
    dec2025Desc: "M31 - Andromeda\nThe Andromeda Galaxy, also known as Messier 31, is a barred spiral galaxy approximately 2.5 million light-years from Earth and the nearest major galaxy to the Milky Way.",
    nov2025: "November 2025",
    nov2025Desc: "M 51 Whirlpool Galaxy, also known as Messier 51a (M51a) or NGC 5194.",
    jan2026: "January 2026",
    jan2026Desc: "M42 The Orion Nebula.",
    jan2026b: "January 2026",
    jan2026bDesc: "Messier 81 (M81), or Bode's Galaxy",
    dec2025b: "December 2025",
    dec2025bDesc: "IC434 - The Horsehead Nebula, a dark nebula in the constellation Orion, located just to the south of Alnitak, the easternmost star of Orion's Belt.",
    jan2026c: "January 2026",
    jan2026cDesc: "IC 1805 - The Heart Nebula, an emission nebula in the constellation Cassiopeia, approximately 7,500 light-years from Earth.",
    mar2026: "March 2026",
    mar2026Desc: "M97 - The Owl Nebula (Snowball Nebula), a planetary nebula in the constellation Ursa Major, approximately 2,030 light-years from Earth.",
    feb2026b: "February 2026",
    feb2026bDesc: "M45 - The Pleiades (Seven Sisters), an open star cluster in Taurus containing young B-type stars, approximately 444 light-years from Earth.",
    apr2026: "{t.apr2026}",
    apr2026Desc: "{t.apr2026Desc}",
    may2026: "{t.may2026}",
    may2026Desc: "{t.may2026Desc}",
    jun2026: "{t.jun2026}",
    jun2026Desc: "{t.jun2026Desc}",
    jul2026: "{t.jul2026}",
    jul2026Desc: "{t.jul2026Desc}",
    aug2026: "{t.aug2026}",
    aug2026Desc: "{t.aug2026Desc}",
    sep2026: "{t.sep2026}",
    sep2026Desc: "{t.sep2026Desc}",
    oct2026: "{t.oct2026}",
    oct2026Desc: "{t.oct2026Desc}",
    nov2026: "{t.nov2026}",
    nov2026Desc: "{t.nov2026Desc}",
    dec2026: "{t.dec2026}",
    dec2026Desc: "{t.dec2026Desc}",
    jan2027: "{t.jan2027}",
    jan2027Desc: "{t.jan2027Desc}",
    feb2027: "{t.feb2027}",
    feb2027Desc: "{t.feb2027Desc}",
    mar2027: "{t.mar2027}",
    mar2027Desc: "{t.mar2027Desc}",
    apr2027: "{t.apr2027}",
    apr2027Desc: "{t.apr2027Desc}",
    may2027: "{t.may2027}",
    may2027Desc: "{t.may2027Desc}",
    jun2027: "{t.jun2027}",
    jun2027Desc: "{t.jun2027Desc}",
    jul2027: "{t.jul2027}",
    jul2027Desc: "{t.jul2027Desc}",
    aug2027: "{t.aug2027}",
    aug2027Desc: "{t.aug2027Desc}",
    sep2027: "{t.sep2027}",
    sep2027Desc: "{t.sep2027Desc}",
    oct2027: "{t.oct2027}",
    oct2027Desc: "{t.oct2027Desc}"
  },
  no: {
    backToHome: "Tilbake til Hjemmet",
    myWork: "Mitt Arbeid",
    more: "mer",
    dec2025: "Desember 2025",
    dec2025Desc: "M31 - Andromeda\nAndromedagalaksen, også kjent som Messier 31, er en spiralgalakse med stang, omtrent 2,5 millioner lysår fra Jorden og den nærmeste store galaksen til Melkeveien.",
    nov2025: "November 2025",
    nov2025Desc: "M 51 Virvelgalaksen, også kjent som Messier 51a (M51a) eller NGC 5194.",
    jan2026: "Januar 2026",
    jan2026Desc: "M42 Oriontåken.",
    jan2026b: "Januar 2026",
    jan2026bDesc: "Messier 81 (M81), eller Bodes Galakse",
    dec2025b: "Desember 2025",
    dec2025bDesc: "IC434 - Hestehode-tåken, en mørk tåke i stjernebildet Orion, som ligger like sør for Alnitak, den østligste stjernen i Orions Belte.",
    jan2026c: "Januar 2026",
    jan2026cDesc: "IC 1805 - Hjertetåken, en emisjonståke i stjernebildet Kassiopeia, omtrent 7 500 lysår fra Jorden.",
    feb2026: "Februar 2026",
    feb2026Desc: "M13 Herkules Kulehop",
    mar2026: "Mars 2026",
    mar2026Desc: "M97 - Ugletåken (Snøballtåken), en planetarisk tåke i stjernebildet Store Bjørn, omtrent 2 030 lysår fra Jorden.",
    feb2026b: "Februar 2026",
    feb2026bDesc: "M45 - Pleiadene (Syvstjernen), en åpen stjernehop i Tyren med unge B-type stjerner, omtrent 444 lysår fra Jorden.",
    apr2026: "{t.apr2026}",
    apr2026Desc: "M104 Sombrero-galaksen",
    may2026: "Mai 2026",
    may2026Desc: "NGC 7293 Helix-tåken",
    jun2026: "Juni 2026",
    jun2026Desc: "M8 Lagunentåken",
    jul2026: "Juli 2026",
    jul2026Desc: "M20 Trifidtåken",
    aug2026: "{t.aug2026}",
    aug2026Desc: "M27 Hanteltåken",
    sep2026: "{t.sep2026}",
    sep2026Desc: "M57 Ringtåken",
    oct2026: "Oktober 2026",
    oct2026Desc: "M1 Krabbtåken",
    nov2026: "{t.nov2026}",
    nov2026Desc: "M33 Triangelgalaksen",
    dec2026: "Desember 2026",
    dec2026Desc: "M45 Plejadene Stjernehop",
    jan2027: "Januar 2027",
    jan2027Desc: "M16 Ørnetåken",
    feb2027: "Februar 2027",
    feb2027Desc: "NGC 6992 Slørtåken",
    mar2027: "Mars 2027",
    mar2027Desc: "M82 Sigargalaksen",
    apr2027: "{t.apr2027}",
    apr2027Desc: "M17 Omega-tåken",
    may2027: "Mai 2027",
    may2027Desc: "M64 Svarteøyegalaksen",
    jun2027: "Juni 2027",
    jun2027Desc: "NGC 2237 Rosetttåken",
    jul2027: "Juli 2027",
    jul2027Desc: "M74 Fantomgalaksen",
    aug2027: "{t.aug2027}",
    aug2027Desc: "M101 Viftehjulgalaksen",
    sep2027: "{t.sep2027}",
    sep2027Desc: "NGC 253 Skulptørgalaksen",
    oct2027: "Oktober 2027",
    oct2027Desc: "M106 Seyfertgalaksen"
  },
  pl: {
    backToHome: "Powrót do Strony Głównej",
    myWork: "Moja Praca",
    more: "więcej",
    dec2025: "Grudzień 2025",
    dec2025Desc: "M31 - Andromeda\nGalaktyka Andromedy, znana również jako Messier 31, to spiralna galaktyka z poprzeczką, oddalona od Ziemi o około 2,5 miliona lat świetlnych i najbliższa duża galaktyka do Drogi Mlecznej.",
    nov2025: "Listopad 2025",
    nov2025Desc: "M 51 Galaktyka Wir, znana również jako Messier 51a (M51a) lub NGC 5194.",
    jan2026: "Styczeń 2026",
    jan2026Desc: "M42 Mgławica Oriona.",
    jan2026b: "Styczeń 2026",
    jan2026bDesc: "Messier 81 (M81) lub Galaktyka Bodego",
    dec2025b: "Grudzień 2025",
    dec2025bDesc: "IC434 - Mgławica Koński Łeb, ciemna mgławica w gwiazdozbiorze Oriona, położona na południe od Alnitak, najdalszej na wschód gwiazdy Pasa Oriona.",
    jan2026c: "Styczeń 2026",
    jan2026cDesc: "IC 1805 - Mgławica Serce, mgławica emisyjna w gwiazdozbiorze Kasjopei, oddalona od Ziemi o około 7 500 lat świetlnych.",
    feb2026: "Luty 2026",
    feb2026Desc: "M13 Gromada Kulista w Herkulesie",
    mar2026: "Marzec 2026",
    mar2026Desc: "M97 - Mgławica Sowa (Mgławica Śnieżka), mgławica planetarna w gwiazdozbiorze Wielkiej Niedźwiedzicy, oddalona od Ziemi o około 2 030 lat świetlnych.",
    feb2026b: "Luty 2026",
    feb2026bDesc: "M45 - Plejady (Siedem Sióstr), otwarta gromada gwiazd w Byku zawierająca młode gwiazdy typu B, oddalona od Ziemi o około 444 lata świetlne.",
    apr2026: "Kwiecień 2026",
    apr2026Desc: "M104 Galaktyka Sombrero",
    may2026: "Maj 2026",
    may2026Desc: "NGC 7293 Mgławica Helix",
    jun2026: "Czerwiec 2026",
    jun2026Desc: "M8 Mgławica Laguna",
    jul2026: "Lipiec 2026",
    jul2026Desc: "M20 Mgławica Tryfid",
    aug2026: "Sierpień 2026",
    aug2026Desc: "M27 Mgławica Hantle",
    sep2026: "Wrzesień 2026",
    sep2026Desc: "M57 Mgławica Pierścień",
    oct2026: "Październik 2026",
    oct2026Desc: "M1 Mgławica Krab",
    nov2026: "Listopad 2026",
    nov2026Desc: "M33 Galaktyka Trójkąta",
    dec2026: "Grudzień 2026",
    dec2026Desc: "M45 Gromada Plejad",
    jan2027: "Styczeń 2027",
    jan2027Desc: "M16 Mgławica Orzeł",
    feb2027: "Luty 2027",
    feb2027Desc: "NGC 6992 Mgławica Woalka",
    mar2027: "Marzec 2027",
    mar2027Desc: "M82 Galaktyka Cygaro",
    apr2027: "Kwiecień 2027",
    apr2027Desc: "M17 Mgławica Omega",
    may2027: "Maj 2027",
    may2027Desc: "M64 Galaktyka Czarne Oko",
    jun2027: "Czerwiec 2027",
    jun2027Desc: "NGC 2237 Mgławica Rozeta",
    jul2027: "Lipiec 2027",
    jul2027Desc: "M74 Galaktyka Fantom",
    aug2027: "Sierpień 2027",
    aug2027Desc: "M101 Galaktyka Wiatraczek",
    sep2027: "Wrzesień 2027",
    sep2027Desc: "NGC 253 Galaktyka Rzeźbiarz",
    oct2027: "Październik 2027",
    oct2027Desc: "M106 Galaktyka Seyferta"
  }
};

export default function M31() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [language, setLanguage] = useState('en');
  
  const t = translations[language];

  const handleZoomIn = () => {
    setZoomLevel(prev => Math.min(prev + 0.5, 4));
  };

  const handleZoomOut = () => {
    setZoomLevel(prev => Math.max(prev - 0.5, 1));
  };

  const closeModal = () => {
    setSelectedImage(null);
    setZoomLevel(1);
    setPosition({ x: 0, y: 0 });
  };

  // Handle mouse down - start dragging
  const handleMouseDown = (e) => {
    if (zoomLevel > 1) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - position.x,
        y: e.clientY - position.y
      });
    }
  };

  // Handle mouse move - drag image
  const handleMouseMove = (e) => {
    if (isDragging && zoomLevel > 1) {
      setPosition({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y
      });
    }
  };

  // Handle mouse up - stop dragging
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Reset position when zoom changes
  useEffect(() => {
    if (zoomLevel === 1) {
      setPosition({ x: 0, y: 0 });
    }
  }, [zoomLevel]);

  // Mouse wheel zoom handler
  useEffect(() => {
    if (!selectedImage) return;

    const handleWheel = (e) => {
      e.preventDefault();
      
      if (e.deltaY < 0) {
        // Scroll up - zoom in
        setZoomLevel(prev => Math.min(prev + 0.25, 4));
      } else {
        // Scroll down - zoom out
        setZoomLevel(prev => Math.max(prev - 0.25, 1));
      }
    };

    const modalElement = document.querySelector('[data-testid="image-modal"]');
    if (modalElement) {
      modalElement.addEventListener('wheel', handleWheel, { passive: false });
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener('wheel', handleWheel);
      }
    };
  }, [selectedImage]);

  return (
    <div className="min-h-screen">
      <StarBackground />
      
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/5 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-white/80 hover:text-white transition-colors duration-300">
            <ArrowLeft className="w-5 h-5" />
            <span>{t.backToHome}</span>
          </Link>
          
          {/* Language Selector */}
          <div className="flex items-center gap-2">
            <button 
              className={`transition-colors duration-300 px-3 py-1 rounded-full ${
                language === 'en' 
                  ? 'bg-white/20 text-white' 
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
              onClick={() => setLanguage('en')}
              data-testid="lang-en-btn"
            >
              EN
            </button>
            <button 
              className={`transition-colors duration-300 px-3 py-1 rounded-full ${
                language === 'no' 
                  ? 'bg-white/20 text-white' 
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
              onClick={() => setLanguage('no')}
              data-testid="lang-no-btn"
            >
              NO
            </button>
            <button 
              className={`transition-colors duration-300 px-3 py-1 rounded-full ${
                language === 'pl' 
                  ? 'bg-white/20 text-white' 
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
              onClick={() => setLanguage('pl')}
              data-testid="lang-pl-btn"
            >
              PL
            </button>
          </div>
        </div>
      </nav>

      {/* Content */}
      <section className="relative pt-32 pb-24 px-8 min-h-screen" data-testid="m31-section">
        <div className="max-w-6xl mx-auto">
          {/* Hero */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="text-center mb-16"
          >
            <h1 
              className="text-5xl sm:text-6xl lg:text-7xl font-black mb-6"
              style={{ fontFamily: 'Unbounded, sans-serif' }}
              data-testid="m31-title"
            >
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400">
                {t.myWork}
              </span>
            </h1>
          </motion.div>

          {/* Gallery Grid */}
          <motion.div 
            className="grid grid-cols-1 md:grid-cols-2 gap-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            {/* Project Card 1 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-purple-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-1"
            >
              <div 
                className="aspect-video bg-gradient-to-br from-purple-900/30 to-cyan-900/30 rounded-xl mb-4 overflow-hidden cursor-pointer group"
                onClick={() => setSelectedImage("https://customer-assets.emergentagent.com/job_5111349b-9fb5-449f-9203-3144233eff50/artifacts/n7pig0zl_PixVerse_Image_Effect_prompt_Layered%20image%20mor.jpg")}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_5111349b-9fb5-449f-9203-3144233eff50/artifacts/n7pig0zl_PixVerse_Image_Effect_prompt_Layered%20image%20mor.jpg"
                  alt="21.12.2025"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.dec2025}
              </h3>
              <p className="text-white/70" style={{ whiteSpace: 'pre-line' }}>
                {t.dec2025Desc}{' '}
                <Link to="/andromeda-details" className="text-purple-400 hover:text-purple-300 underline transition-colors duration-300">
                  {t.more}
                </Link>
              </p>
            </motion.div>

            {/* Project Card 2 - M51 Whirlpool */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-cyan-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-2"
            >
              <div 
                className="aspect-video bg-gradient-to-br from-cyan-900/30 to-pink-900/30 rounded-xl mb-4 overflow-hidden cursor-pointer group"
                onClick={() => setSelectedImage("https://customer-assets.emergentagent.com/job_5111349b-9fb5-449f-9203-3144233eff50/artifacts/gutqzi9i_2026-01-11T17.03.44.png")}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_5111349b-9fb5-449f-9203-3144233eff50/artifacts/gutqzi9i_2026-01-11T17.03.44.png"
                  alt="M51 Whirlpool Galaxy"
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                  style={{ objectFit: 'cover', objectPosition: 'center' }}
                />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.nov2025}
              </h3>
              <p className="text-white/70">
                {t.nov2025Desc}{' '}
                <Link to="/whirlpool-details" className="text-cyan-400 hover:text-cyan-300 underline transition-colors duration-300">
                  {t.more}
                </Link>
              </p>
            </motion.div>

            {/* Project Card 3 - M42 Orion */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-pink-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-3"
            >
              <div 
                className="aspect-video bg-gradient-to-br from-pink-900/30 to-purple-900/30 rounded-xl mb-4 overflow-hidden cursor-pointer group"
                onClick={() => setSelectedImage("https://customer-assets.emergentagent.com/job_5111349b-9fb5-449f-9203-3144233eff50/artifacts/61wbw82t_PixVerse_Image_Effect_prompt_more%20details.jpg")}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_5111349b-9fb5-449f-9203-3144233eff50/artifacts/61wbw82t_PixVerse_Image_Effect_prompt_more%20details.jpg"
                  alt="M42 Orion Nebula"
                  className="w-full h-full transition-transform duration-500 group-hover:scale-110"
                  style={{ objectFit: 'cover', objectPosition: 'center' }}
                />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.jan2026}
              </h3>
              <p className="text-white/70">
                {t.jan2026Desc}{' '}
                <Link to="/orion-details" className="text-pink-400 hover:text-pink-300 underline transition-colors duration-300">
                  {t.more}
                </Link>
              </p>
            </motion.div>

            {/* Project Card 4 - M81 Bode */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-purple-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-4"
            >
              <div 
                className="aspect-video bg-gradient-to-br from-purple-900/30 to-pink-900/30 rounded-xl mb-4 overflow-hidden cursor-pointer group"
                onClick={() => setSelectedImage("https://customer-assets.emergentagent.com/job_celestial-showcase/artifacts/wn51yv7t_2025-12-23T19.04.44.png")}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_celestial-showcase/artifacts/wn51yv7t_2025-12-23T19.04.44.png"
                  alt="M81 Bode's Galaxy"
                  className="w-full h-full transition-transform duration-500 group-hover:scale-110"
                  style={{ objectFit: 'cover', objectPosition: 'center' }}
                />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.jan2026b}
              </h3>
              <p className="text-white/70">
                {t.jan2026bDesc}{' '}
                <Link to="/bode-details" className="text-purple-400 hover:text-purple-300 underline transition-colors duration-300">
                  {t.more}
                </Link>
              </p>
            </motion.div>

            {/* Project Card 5 - Horsehead Nebula */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-cyan-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-5"
            >
              <div 
                className="aspect-video bg-gradient-to-br from-cyan-900/30 to-blue-900/30 rounded-xl mb-4 overflow-hidden cursor-pointer group"
                onClick={() => setSelectedImage("https://customer-assets.emergentagent.com/job_3a687b85-2230-4346-acc7-017f0089db70/artifacts/f2wweajk_2026-01-11T17.34.41.png")}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_3a687b85-2230-4346-acc7-017f0089db70/artifacts/f2wweajk_2026-01-11T17.34.41.png"
                  alt="IC434 Horsehead Nebula"
                  className="w-full h-full transition-transform duration-500 group-hover:scale-110"
                  style={{ objectFit: 'cover', objectPosition: 'center' }}
                />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.dec2025b}
              </h3>
              <p className="text-white/70">
                {t.dec2025bDesc}{' '}
                <Link to="/horsehead-details" className="text-cyan-400 hover:text-cyan-300 underline transition-colors duration-300">
                  {t.more}
                </Link>
              </p>
            </motion.div>

            {/* Project Card 6 - Heart Nebula */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-pink-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-6"
            >
              <div 
                className="aspect-video bg-gradient-to-br from-pink-900/30 to-red-900/30 rounded-xl mb-4 overflow-hidden cursor-pointer group"
                onClick={() => setSelectedImage("https://customer-assets.emergentagent.com/job_3a687b85-2230-4346-acc7-017f0089db70/artifacts/0yt3p6y8_2026-02-07T22.22.02.png")}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_3a687b85-2230-4346-acc7-017f0089db70/artifacts/0yt3p6y8_2026-02-07T22.22.02.png"
                  alt="IC1805 Heart Nebula"
                  className="w-full h-full transition-transform duration-500 group-hover:scale-110"
                  style={{ objectFit: 'cover', objectPosition: 'center' }}
                />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.jan2026c}
              </h3>
              <p className="text-white/70">
                {t.jan2026cDesc}{' '}
                <Link to="/heart-details" className="text-pink-400 hover:text-pink-300 underline transition-colors duration-300">
                  {t.more}
                </Link>
              </p>
            </motion.div>

            {/* Project Card 7 - M97 Snowball Nebula */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-purple-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-7"
            >
              <div 
                className="aspect-video bg-gradient-to-br from-purple-900/30 to-indigo-900/30 rounded-xl mb-4 overflow-hidden cursor-pointer group"
                onClick={() => setSelectedImage("https://customer-assets.emergentagent.com/job_3a687b85-2230-4346-acc7-017f0089db70/artifacts/do21vdot_2026-03-02T20.27.13.png")}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_3a687b85-2230-4346-acc7-017f0089db70/artifacts/do21vdot_2026-03-02T20.27.13.png"
                  alt="M97 Snowball Nebula"
                  className="w-full h-full transition-transform duration-500 group-hover:scale-110"
                  style={{ objectFit: 'cover', objectPosition: 'center' }}
                />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.mar2026}
              </h3>
              <p className="text-white/70">
                {t.mar2026Desc}{' '}
                <Link to="/snowball-details" className="text-purple-400 hover:text-purple-300 underline transition-colors duration-300">
                  {t.more}
                </Link>
              </p>
            </motion.div>

            {/* Project Card 8 - M45 Pleiades */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-cyan-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-8"
            >
              <div 
                className="aspect-video bg-gradient-to-br from-cyan-900/30 to-teal-900/30 rounded-xl mb-4 overflow-hidden cursor-pointer group"
                onClick={() => setSelectedImage("https://customer-assets.emergentagent.com/job_3a687b85-2230-4346-acc7-017f0089db70/artifacts/2rae73p9_2026-03-03T17.33.15.png")}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_3a687b85-2230-4346-acc7-017f0089db70/artifacts/2rae73p9_2026-03-03T17.33.15.png"
                  alt="M45 Pleiades Seven Sisters"
                  className="w-full h-full transition-transform duration-500 group-hover:scale-110"
                  style={{ objectFit: 'cover', objectPosition: 'center' }}
                />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.feb2026b}
              </h3>
              <p className="text-white/70">
                {t.feb2026bDesc}{' '}
                <Link to="/pleiades-details" className="text-cyan-400 hover:text-cyan-300 underline transition-colors duration-300">
                  {t.more}
                </Link>
              </p>
            </motion.div>

            {/* Project Card 9 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-pink-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-9"
            >
              <div className="aspect-video bg-gradient-to-br from-pink-900/30 to-purple-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-pink-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.jul2026}
              </h3>
              <p className="text-white/70">
                {t.jul2026Desc}
              </p>
            </motion.div>

            {/* Project Card 10 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-purple-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-10"
            >
              <div className="aspect-video bg-gradient-to-br from-purple-900/30 to-pink-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-purple-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.aug2026}
              </h3>
              <p className="text-white/70">
                {t.aug2026Desc}
              </p>
            </motion.div>

            {/* Project Card 11 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-cyan-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-11"
            >
              <div className="aspect-video bg-gradient-to-br from-cyan-900/30 to-blue-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-cyan-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.sep2026}
              </h3>
              <p className="text-white/70">
                {t.sep2026Desc}
              </p>
            </motion.div>

            {/* Project Card 12 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-pink-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-12"
            >
              <div className="aspect-video bg-gradient-to-br from-pink-900/30 to-red-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-pink-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.oct2026}
              </h3>
              <p className="text-white/70">
                {t.oct2026Desc}
              </p>
            </motion.div>

            {/* Project Card 13 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-purple-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-13"
            >
              <div className="aspect-video bg-gradient-to-br from-purple-900/30 to-indigo-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-purple-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.nov2026}
              </h3>
              <p className="text-white/70">
                {t.nov2026Desc}
              </p>
            </motion.div>

            {/* Project Card 14 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-cyan-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-14"
            >
              <div className="aspect-video bg-gradient-to-br from-cyan-900/30 to-teal-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-cyan-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.dec2026}
              </h3>
              <p className="text-white/70">
                {t.dec2026Desc}
              </p>
            </motion.div>

            {/* Project Card 15 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-pink-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-15"
            >
              <div className="aspect-video bg-gradient-to-br from-pink-900/30 to-purple-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-pink-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.jan2027}
              </h3>
              <p className="text-white/70">
                {t.jan2027Desc}
              </p>
            </motion.div>

            {/* Project Card 16 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-purple-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-16"
            >
              <div className="aspect-video bg-gradient-to-br from-purple-900/30 to-pink-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-purple-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.feb2027}
              </h3>
              <p className="text-white/70">
                {t.feb2027Desc}
              </p>
            </motion.div>

            {/* Project Card 17 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-cyan-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-17"
            >
              <div className="aspect-video bg-gradient-to-br from-cyan-900/30 to-blue-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-cyan-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.mar2027}
              </h3>
              <p className="text-white/70">
                {t.mar2027Desc}
              </p>
            </motion.div>

            {/* Project Card 18 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-pink-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-18"
            >
              <div className="aspect-video bg-gradient-to-br from-pink-900/30 to-red-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-pink-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.apr2027}
              </h3>
              <p className="text-white/70">
                {t.apr2027Desc}
              </p>
            </motion.div>

            {/* Project Card 19 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-purple-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-19"
            >
              <div className="aspect-video bg-gradient-to-br from-purple-900/30 to-indigo-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-purple-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.may2027}
              </h3>
              <p className="text-white/70">
                {t.may2027Desc}
              </p>
            </motion.div>

            {/* Project Card 20 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-cyan-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-20"
            >
              <div className="aspect-video bg-gradient-to-br from-cyan-900/30 to-teal-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-cyan-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.jun2027}
              </h3>
              <p className="text-white/70">
                {t.jun2027Desc}
              </p>
            </motion.div>

            {/* Project Card 21 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-pink-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-21"
            >
              <div className="aspect-video bg-gradient-to-br from-pink-900/30 to-purple-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-pink-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.jul2027}
              </h3>
              <p className="text-white/70">
                {t.jul2027Desc}
              </p>
            </motion.div>

            {/* Project Card 22 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-purple-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-22"
            >
              <div className="aspect-video bg-gradient-to-br from-purple-900/30 to-pink-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-purple-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.aug2027}
              </h3>
              <p className="text-white/70">
                {t.aug2027Desc}
              </p>
            </motion.div>

            {/* Project Card 23 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-cyan-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-23"
            >
              <div className="aspect-video bg-gradient-to-br from-cyan-900/30 to-blue-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-cyan-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.sep2027}
              </h3>
              <p className="text-white/70">
                {t.sep2027Desc}
              </p>
            </motion.div>

            {/* Project Card 24 */}
            <motion.div 
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:border-pink-500/50 transition-all duration-500"
              whileHover={{ scale: 1.02 }}
              data-testid="project-card-24"
            >
              <div className="aspect-video bg-gradient-to-br from-pink-900/30 to-red-900/30 rounded-xl mb-4 flex items-center justify-center">
                <Sparkles className="w-16 h-16 text-pink-400/50" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                {t.oct2027}
              </h3>
              <p className="text-white/70">
                {t.oct2027Desc}
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Image Modal/Lightbox */}
      {selectedImage && (
        <motion.div
          className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex flex-col items-center justify-center p-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={closeModal}
          data-testid="image-modal"
        >
          {/* Close Button */}
          <button
            className="absolute top-8 right-8 text-white hover:text-purple-400 transition-colors duration-300 z-10"
            onClick={closeModal}
            data-testid="close-modal-btn"
          >
            <X className="w-10 h-10" />
          </button>

          {/* Zoom Controls */}
          <div className="absolute top-8 left-8 flex gap-3 z-10">
            <button
              className={`bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-white/20 transition-all duration-300 rounded-full p-3 ${
                zoomLevel >= 4 ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              onClick={(e) => {
                e.stopPropagation();
                handleZoomIn();
              }}
              disabled={zoomLevel >= 4}
              data-testid="zoom-in-btn"
            >
              <ZoomIn className="w-6 h-6" />
            </button>
            <button
              className={`bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-white/20 transition-all duration-300 rounded-full p-3 ${
                zoomLevel <= 1 ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              onClick={(e) => {
                e.stopPropagation();
                handleZoomOut();
              }}
              disabled={zoomLevel <= 1}
              data-testid="zoom-out-btn"
            >
              <ZoomOut className="w-6 h-6" />
            </button>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 text-white rounded-full px-4 flex items-center">
              <span className="text-sm font-bold">{Math.round(zoomLevel * 100)}%</span>
            </div>
          </div>

          {/* Large Image Container with Scroll */}
          <div 
            className="overflow-hidden max-w-full max-h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            style={{
              width: '90vw',
              height: '80vh',
              cursor: zoomLevel > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default'
            }}
          >
            <img
              src={selectedImage}
              alt="Full size view"
              className="rounded-lg shadow-[0_0_100px_rgba(112,66,248,0.5)] transition-transform duration-300 ease-in-out select-none"
              style={{
                transform: `scale(${zoomLevel}) translate(${position.x / zoomLevel}px, ${position.y / zoomLevel}px)`,
                transformOrigin: 'center center',
                maxWidth: zoomLevel === 1 ? '100%' : 'none',
                maxHeight: zoomLevel === 1 ? '100%' : 'none',
                pointerEvents: 'none'
              }}
              draggable={false}
              data-testid="modal-image"
            />
          </div>
        </motion.div>
      )}
    </div>
  );
}
